/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import {createContext} from "react";

const OnboardingContext = createContext();

export {
  OnboardingContext
};
